<template>
  <div style="width:100%;overflow-y:auto;overflow-x:hidden;height:100%;">
    <div style="padding:0px;width:100%;">
      <div style="width:240px;float: left;"
           class="whiteBox searchbox">
        <h4>
          <i class="el-icon-d-arrow-right"></i> 筛选条件
        </h4>
        <div class="filter-container search-box">
          <el-form label-position="top"
                   label-width="80px">
            <el-form-item label="搜索">
              <el-input size="mini"
                        style="width:220px;top:2px;"
                        placeholder="姓名或手机号码"
                        v-model="searchQuery.key"></el-input>
            </el-form-item>
            <el-form-item label="创建时间">
              <el-date-picker v-model="searchQuery.dateRange1"
                              type="daterange"
                              size="mini"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"
                              :picker-options="datePickerOption"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="线索来源">
              <el-select size="mini"
                         style="width:180px;"
                         v-model="searchQuery.fromType">
                <el-option label="全部"
                           :value="0"></el-option>
                <el-option label="线上"
                           :value="1"></el-option>
                <el-option label="线下"
                           :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="线下来源"
                          v-if="searchQuery.fromType == 2">
              <el-select size="mini"
                         style="width:180px;"
                         v-model="searchQuery.fromSources"
                         @change="fromSourceChange"
                         ref="subject">
                <el-option v-for="item in fromSourceOptions"
                           :key="item.dataValue"
                           :label="item.dataDisplay"
                           :value="item.dataValue"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="线上来源"
                          v-if="searchQuery.fromType == 1">
              <el-select size="mini"
                         style="width:180px;"
                         multiple
                         v-model="searchQuery.onlineSource">
                <el-option v-for="item in importSourceOptions"
                           :key="item.dataName"
                           :label="item.dataDisplay"
                           :value="item.dataName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户经理"
                          v-if="members.length > 1">
              <el-select size="mini"
                         style="width:180px;"
                         multiple
                         v-model="searchQuery.member">
                <el-option v-for="item in members"
                           :key="item.memberId"
                           :label="item.userName"
                           :value="item.memberId"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="购车类型">
              <el-select size="mini"
                         style="width:180px;"
                         multiple
                         v-model="searchQuery.businessTypes">
                <el-option v-for="item in businessTypeOptions"
                           :key="item.dataValue"
                           :label="item.dataDisplay"
                           :value="item.dataValue"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="订购车型">
              <el-cascader size="mini"
                           class="filter-item"
                           style="width: 180px;"
                           placeholder="选择订购车型"
                           filterable
                           clearable
                           :show-all-levels="true"
                           :options="carOptions"
                           v-model="searchQuery.modelId"></el-cascader>
            </el-form-item>
          </el-form>
          <div style="margin-top:20px;">
            <el-button size="small"
                       icon="el-icon-search"
                       class="filter-item"
                       @click="retrieveTables">筛选</el-button>
            <el-button size="small"
                       icon="el-icon-refresh"
                       class="filter-item"
                       @click="reset">重置</el-button>
          </div>
        </div>
      </div>
      <div style="margin-left: 220px; overflow:auto;margin-right:20px;padding:0px 20px;">
        <h1 class="page_title">待配车</h1>
        <!-- <div class="filter-container">
          <div style="margin-bottom: 10px;">
            <el-radio-group size="small"
                            v-model="searchQuery.isDone"
                            @change="retrieveTables">
              <el-radio-button :label="false">待审核({{count0}})</el-radio-button>
              <el-radio-button :label="true">完成</el-radio-button>
            </el-radio-group>
          </div>
        </div> -->
        <el-table :data="tableRecords"
                  stripe
                  style="margin-top:10px"
                  v-loading="listLoading">
          <el-table-column align="left"
                           label="创建时间"
                           width="160">
            <template slot-scope="scope">{{scope.row.createdAt  | parseTime('{y}-{m}-{d} {h}:{i}')}}</template>
          </el-table-column>
          <el-table-column align="left"
                           label="客户姓名"
                           min-width="140">
            <template slot-scope="scope">
              <span class="click_link" @click="toDetailPage(scope.row)">
                {{ `${scope.row.customerType === 1 ? scope.row.customerName : scope.row.companyName}${ scope.row.customerPhone ? ` - ` : ''}`  }}
                <Desensitize
                  v-if="scope.row.customerPhone"
                  :text="scope.row.customerPhone"
                  :userType="1"
                  :clearText="true"
                  :queryKey="scope.row.id"
                  :key="scope.row.id"
                />
              </span>
            </template>
          </el-table-column>
          <el-table-column align="left"
                           label="状态"
                           width="120">
            <template slot-scope="scope">{{scope.row.status | statusFitter}}</template>
          </el-table-column>
          <el-table-column align="left"
                           label="订购车型"
                           min-width="180">
            <template slot-scope="scope">{{scope.row.modelDisplay}}</template>
          </el-table-column>
          <el-table-column align="left"
                           label="预计交车时间"
                           width="160">
            <template slot-scope="scope"><span v-if="scope.row.deliverDate != 0">{{scope.row.deliverDate  | parseTime('{y}-{m}-{d}')}}</span></template>
          </el-table-column>
          <el-table-column align="left"
                           label="客户经理"
                           width="120">
            <template slot-scope="scope">{{scope.row.ownerName}}</template>
          </el-table-column>
          <el-table-column align="left"
                           label="订金"
                           width="160">
            <template slot-scope="scope">{{scope.row.paymentDown}}</template>
          </el-table-column>
          <!-- <el-table-column align="left"
                           label="成交金额"
                           width="130">
            <template slot-scope="scope">{{scope.row.paymentDeal}}</template>
          </el-table-column> -->
        </el-table>
        <div class="pagination-container">
          <el-pagination background
                         @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page="listQuery.page"
                         :page-sizes="[10,20,30,50]"
                         :page-size="listQuery.limit"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="total"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Desensitize from "@/components/Desensitize/Desensitize.vue";
var order_vm
export default {
  components: {
    Desensitize
  },
  data() {
    order_vm = this
    return {
      listLoading: false,
      dealer: this.$common.getDealer(),
      user: this.$common.getUser(),
      isAdmin: this.$common.getAdmin(),
      searchQuery: {
        key: '',
        fromType: 0,
        dateRange1: null,
        member: [],
        fromSources: [],
        onlineSource: [],
        businessTypes: [],
        isOther: 0,
        isReport: 0,
        sortType: 0,
        modelId: [],
      },
      datePickerOption: {
        firstDayOfWeek: 1,
        shortcuts: [
          {
            text: '今日',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '昨日',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1)
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一年',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 364)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      members: [],
      customerOrderOptions: [
        { dataDisplay: '全部', dataValue: 0 },
        { dataDisplay: '未到店', dataValue: 1 },
        { dataDisplay: '已到店', dataValue: 2 },
        { dataDisplay: '订车', dataValue: 3 },
        { dataDisplay: '成交', dataValue: 4 },
        { dataDisplay: '战败', dataValue: 5 },
        { dataDisplay: '休眠', dataValue: 6 },
      ],
      businessTypeOptions: [],
      fromSourceOptions: [],
      importSourceOptions: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 10,
      },
      tableRecords: [],
      count0: 0,
      customizationList: [],
      carOptions: [], // 订购车型
      orderStatusDics: [],
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      let form = from.path
      if (form === '/approved' || form === '/submitted') {
        try {
          var listFilters = JSON.parse(sessionStorage.getItem('listFilters5'))
          vm.searchQuery = listFilters.searchQuery
          vm.total = listFilters.total
          vm.listQuery = listFilters.listQuery
        } catch (error) {
          console.log(error)
        }
      }
      vm.getList()
      //   vm.retrieveTotal()
    })
  },
  created() {
    var baseInfo = this.$common.getBaseInfo()
    this.fromSourceOptions = baseInfo.customerFromSources
    this.importSourceOptions = baseInfo.importSources
    this.businessTypeOptions = baseInfo.businessTypes
    this.orderStatusDics = baseInfo.orderStatusDics
    this.retrieveMembers()
    this.getcustomizationList()
    this.retrieveCarOptions()
  },
  methods: {
    retrieveCarOptions() {
      var parent = this
      this.$httpAuth
        .post('/v1/dealerRpc/vehicleJsonTree', {
          dealerId: this.dealer.dealerId,
        })
        .then(function (response) {
          parent.carOptions = response.data.data
        })
    },
    fromSourceChange(val) {
      if (val == 99) {
        this.$refs.subject.blur()
      }
    },
    // 其他来源数据
    getcustomizationList() {
      this.$httpAuth
        .post('/v2/appDealerManagerService/sourceList', {
          dealerId: this.dealer.dealerId,
        })
        .then((res) => {
          this.customizationList = res.data.data
        })
    },
    retrieveMembers() {
      var parent = this
      this.$httpAuth
      this.$httpAuth
        .post('/v1/dealerMemberRpc/managerMembers', {
          dealerId: this.dealer.dealerId,
        })
        .then(function (response) {
          parent.members = response.data.data
          //   if (!parent.isAdmin) {
          //     parent.members.push({
          //       memberId: parent.dealer.userId,
          //       userName: parent.dealer.name,
          //     })
          //   }
        })
    },
    retrieveTables() {
      this.listQuery.page = 1
      this.getList()
    },
    // 重置
    reset() {
      this.orderType = 0
      this.searchQuery = {
        key: '',
        fromType: 0,
        dateRange1: null,
        member: [],
        fromSources: [],
        onlineSource: [],
        businessTypes: [],
        isOther: 0,
        isReport: 0,
        sortType: 0,
        modelId: [],
      }
      this.retrieveTables()
    },
    // 获取列表数据
    getList() {
      var parent = this
      if (this.searchQuery.fromType == 1) {
        this.searchQuery.fromSources = []
      } else if (this.searchQuery.fromType == 2) {
        this.searchQuery.onlineSource = []
      } else {
        this.searchQuery.fromSources = []
        this.searchQuery.onlineSource = []
      }
      let params = {
        dealerId: this.dealer.dealerId,
        pageStart: (this.listQuery.page - 1) * this.listQuery.limit,
        pageCount: this.listQuery.limit,
        saleIds:
          this.searchQuery.member.length > 0
            ? this.searchQuery.member.join(',')
            : '',
        createdDate: {
          start:
            this.searchQuery.dateRange1 != null
              ? this.searchQuery.dateRange1[0]
              : '',
          end:
            this.searchQuery.dateRange1 != null
              ? this.searchQuery.dateRange1[1]
              : '',
        },
        key: this.searchQuery.key,
        fromType: this.searchQuery.fromType,
        fromSources:
          this.searchQuery.fromSources.length > 0
            ? this.searchQuery.fromSources.join(',')
            : '',
        onlineSources:
          this.searchQuery.onlineSource.length > 0
            ? this.searchQuery.onlineSource.join(',')
            : '',
        businessTypes:
          this.searchQuery.businessTypes.length > 0
            ? this.searchQuery.businessTypes.join(',')
            : '',
        orderStatus: '3',
        isOther: this.searchQuery.isOther,
        isReport: this.searchQuery.isReport,
        sortType: this.searchQuery.sortType,
        modelId:
          this.searchQuery.modelId.length > 0
            ? Number(this.searchQuery.modelId[1])
            : 0,
        seriesId:
          this.searchQuery.modelId.length > 0
            ? Number(this.searchQuery.modelId[0])
            : 0,
      }
      this.listLoading = true
      this.$httpAuth
        .post('/v2/appCustomerService/orders', params)
        .then(function (response) {
          parent.listLoading = false
          parent.tableRecords = response.data.data
          parent.total = response.data.total
        })
        .catch(() => {})
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    toDetailPage(item) {
      var listFilters = {
        searchQuery: this.searchQuery,
        sortType: this.sortType,
        total: this.total,
        listQuery: this.listQuery,
      }
      sessionStorage.setItem('listFilters5', JSON.stringify(listFilters))
      sessionStorage.setItem('form', '')
      this.$router.push({
        path: '/approved',
        query: { id: item.id },
      })
    },
  },
  filters: {
    statusFitter(val) {
      for (var i = 0; i < order_vm.orderStatusDics.length; i++) {
        var o = order_vm.orderStatusDics[i]
        if (o.dataValue == val) {
          return o.dataDisplay
        }
      }
      return ''
    },
  },
}
</script>

<style>
</style>
